import { z } from 'zod'

import { AgentOutputActionEnum } from './agent-decision.ts'
import { msTimestampSchema } from './common.ts'
import { ProposalSystemErrorSchema } from './proposal.ts'

export const AgentLastTickGateKeyEnum = z.enum(['ramp_up', 'daily_cap', 'blackout', 'min_interval'])
export const AgentLastTickGateStateEnum = z.enum(['clear', 'active', 'blocked', 'unevaluated'])

export const AgentLastTickGateSchema = z.object({
  key: AgentLastTickGateKeyEnum,
  label: z.string().min(1),
  detail: z.string().min(1),
  state: AgentLastTickGateStateEnum
})

export const AgentLastTickResponseSchema = z.object({
  ranAt: msTimestampSchema.nullable(),
  action: AgentOutputActionEnum.nullable(),
  confidence: z.number().min(0).max(1).nullable(),
  systemError: ProposalSystemErrorSchema.nullable(),
  summary: z.string().min(1),
  influencingGate: AgentLastTickGateKeyEnum.nullable(),
  gates: z.array(AgentLastTickGateSchema),
  nextRunAt: msTimestampSchema
})

export type AgentLastTickResponse = z.infer<typeof AgentLastTickResponseSchema>
